import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useParams } from 'react-router-dom';
import { useAuth } from "../../utils/auth/useAuth";
import { useLocation } from "react-router-dom";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from '../../constants/localStoreKeys';
import { Layout, Row, Col } from "antd";
import { LoadingSpinner, Card, Breadcrumb, ButtonIcon, Icon, Button } from "pepsico-ds";
import { useNavigate } from "react-router-dom";
import "../../components/Cards/Cards.scss"
import CustomButtons from "../../components/Cards/CustomButtons";
import ShareNewsModal from "../../components/Cards/ShareNewsModal";
import { FetchNewsDetailAction, UpdateBookmarkAction } from "../../redux/action/RISIAction";
import Vector from '../../assets/Vector.png'
import { useToast } from '../../components/Toast/ToastContext';
import { call7DaysNpsLogic, formatIntoDropdownData } from "../../utils/utils";

function getSourceBadgeColorClass(source = "") 
{

    const normalizedSource = (source || "").toLowerCase();
    if (normalizedSource.includes("smartcube")) { 
        return "news-source-badge-purple";
    }
    if (normalizedSource.includes("fastmarkets") || normalizedSource.includes("risi")) {
        return "news-source-badge-orange";
    }
    return "news-source-badge-gray";
}

function SourceBadge({ text }) {
    if (!text) { 
        return null;
    }


    return (
        <span className={`news-source-badge ${getSourceBadgeColorClass(text)}`}>{text}</span>
    );
}

function DetailNews() {
    const { state } = useLocation();
    const { authState } = useAuth();
    const currentFilters = state?.currentFilters ?? {};
    const navigate = useNavigate();
	const dispatch = useDispatch();
    const { id } = useParams();
	const [userInfo, setUserInfo] = useState({});
	const [currentNews, setCurrentNews] = useState({});
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [shareFlag, setShareFlag]= useState(false)
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const newsArticleBookmarkCount = useSelector((state) => state?.localData?.data[localStoreKeys.newsArticleBookmarkCount]);
    const maxAllowedBookmarks = useSelector((state) => state?.localData?.data[localStoreKeys.maxAllowedBookmarks]);
    
	 const userData = useSelector((state) => state.getLandingPageReducer);
	 const newsData = useSelector((state) => state.getNewsDetailReducer);
	 const bookmarkSaveData = useSelector((state) => state.getUpdateBookmarkReducer);
    const { showToast } = useToast();
    const ref = React.useRef(null);
	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				localStorage.setItem('userInfoEmailID', btoa(JSON.stringify(user?.useremail || user?.email)))
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
		setIsDataLoading(true) 
		fetchUserInfo();
	}, []);


    
	/* istanbul ignore next */
    useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_NEWS_DETAIL_ACTION', 
                payload: "RESET_NEWS_DETAIL_ACTION" 
            });
            dispatch({ 
                type: 'RESET_SHARE_LIST_ACTION', 
                payload: "RESET_SHARE_LIST_ACTION" 
            });
        };
    }, []);

    
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && newsData && newsData.type === "SUCCESS_NEWS_DETAIL_ACTION") {
            setIsDataLoading(false);
            setCurrentNews(newsData);
            dispatch(setKeyValue({ key: localStoreKeys.newsArticleBookmarkCount, value: newsData?.totalBookMark }))
            dispatch(setKeyValue({ key: localStoreKeys.maxAllowedBookmarks, value: newsData?.totalBookmarksAllowed }))
        }
    }, [newsData])
     /* istanbul ignore next */
     useEffect(() => {
        if (isUserDataFetched && bookmarkSaveData && bookmarkSaveData.type === "SUCCESS_UPDATE_BOOKMARK_ACTION") {
            dispatch(setKeyValue({ key: localStoreKeys.newsArticleBookmarkCount, value: bookmarkSaveData?.totalBookMark }))
            
            // showToast('success', "Bookmark Saved Successfully", {
            //     icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            // });
        }
    }, [bookmarkSaveData])
	
    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {

            // dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // // 7 days NPS logic
            // const now = Date.now(); // current timestamp in milliseconds

            // const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            // const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }

            call7DaysNpsLogic(dispatch, userData)
            setIsDataLoading(true)
            dispatch(FetchNewsDetailAction(id,userInfo?.email));
            
        }
		
    }, [userData])

    
	/* istanbul ignore next */
    const bookmarkNews = (news) => {
        const requestObject = {
            emailId: userInfo?.email || '',
            newsId: id || '',
            type: news?.isBookmarked?"SAVE":"DELETE"
        };
        dispatch(UpdateBookmarkAction(requestObject));
    }

	/* istanbul ignore next */
    function decodeEntities(str = "") {
        const doc = new DOMParser().parseFromString(str, "text/html");
        return doc.documentElement.textContent;
    }
    
	/* istanbul ignore next */
    const handleSharePopup = () => {
        setShareFlag(prev => !prev)
    }

	/* istanbul ignore next */
	if(authState?.isAuthenticated){
		return(
                <>    
                    {
                        (isDataLoading || newsData.type !== "SUCCESS_NEWS_DETAIL_ACTION") ? 
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :

                        <>
                            <div ref={ref} >
                            <ShareNewsModal
                                visible={shareFlag}
                                onClose={handleSharePopup}
                                newsItem={{ id, source: currentNews?.source }}
                                userEmail={userInfo?.email}
                            />
                            <Breadcrumb
                                breadcrumbs={[
                                    {
                                    label: 'Home',
                                    onClick: function aFe(){navigate("/overview")},
                                    },
                                    {
                                    label: 'News & Trends',
                                    onClick: function aFe(){navigate("/overview/news", { state: { currentFilters: currentFilters, loadPreviousSelection:true }})} // /overview/news?restore=1
                                    },
                                    {
                                    label: decodeEntities(currentNews?.title) || "",
                                    onClick: function aFe(){}
                                    }
                                ]}
                                className="ph-breadcrumb"
                                style={{padding: '30px 30px 30px 0px', width: "100%"}}
                                homeIcon={{
                                    icon: 'track_changes'
                                }}
                            />
                            

                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Card style={{ height: '100%', padding: "48px" }}>
                                        <div style={{width:"100%", whiteSpace:"normal"}} className="ph-news-detail-content">
                                            {/* <div className="ph-news-detail-source" style={{marginBottom: "16px"}}>{currentNews?.source}</div> */}
                                            <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px"}}>
                                                <div style={{ fontSize: "28px", color: "#2D2D2D", fontWeight: "700", lineHeight: "40px" }}>
                                                    {decodeEntities(currentNews?.title) || ""}
                                                </div>
                                                <div style={{ display:"flex" }}>
                                                    <ButtonIcon
                                                        aria-label="news-share-button-icon"
                                                        data-fs="news-share-button-icon"
                                                        className=""
                                                        color="Icon/Default"
                                                        icon="share"
                                                        label=""
                                                        onClick={function C$e(){
                                                            handleSharePopup()
                                                        }}
                                                        size="medium"
                                                        style={{ marginRight:"0.5rem" }}
                                                        type="default"
                                                    />
                                                    <ButtonIcon
                                                        className=""
                                                        color="Icon/Default"
                                                        icon={currentNews?.isBookmarked?"bookmark":"bookmark_border"}
                                                        label="Bookmark"
                                                        onClick={function C$e(){
                                                            
                                                            const bookmarkValue = !currentNews?.isBookmarked;
                                                            
                                                            if(newsArticleBookmarkCount>=maxAllowedBookmarks && bookmarkValue) { 
                                                                showToast('warning', "You are allowed to bookmark upto "+maxAllowedBookmarks+" articles", {
                                                                    icon: <Icon alt="" icon="warning_amber" size="medium" />
                                                                });
                                                                return;
                                                            }
                                                            const updatedNews = 
                                                            {
                                                                ...currentNews,
                                                                isBookmarked:bookmarkValue
                                                            }
                                                            setCurrentNews(updatedNews)
                                                            bookmarkNews(updatedNews)

                                                        }}
                                                        size="medium"
                                                        style={{ marginRight:"0.5rem" }}
                                                        type="default"
                                                    /> 
                                                    <CustomButtons appList={currentNews?.apps}/>
                                                </div>
                                            </div>
                                            <div style={{ fontSize: "14px", marginBottom:"16px" }}>{currentNews?.time}</div>
                                            <div className="detail-news-app-source-meta" style={{ marginBottom:"16px" }}>
                                                <SourceBadge text={currentNews?.source} />
                                                {currentNews?.tags?.length > 0 &&
                                                    <span className="news-source-tags-text">
                                                        {currentNews.tags.map((tag, index) => (
                                                            <React.Fragment key={`${tag.key}-${index}`}>
                                                                {index > 0 && " | "}
                                                                <span className="news-tag-key">{(tag.key || "").toUpperCase()}</span>: {tag.value}
                                                            </React.Fragment>
                                                        ))}
                                                    </span>
                                                }
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: currentNews?.content }}/>
                                            {/* <div dangerouslySetInnerHTML={{ __html: clean1 }}/> */}
                                        </div>
                                    </Card>  
                                </Col>
                            </Row>
                            <br/>


                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {currentNews?.owner?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {currentNews?.owner?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < currentNews?.owner.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                            </div>

                            <br/>
                            <br/>
                            <footer className="detailnews-tile-footer">
                                    <div style={{display:"flex", width:'100%', justifyContent: 'center'}}>
                                            <Button
                                                size="medium"
                                                text="Back"
                                                variant="tertiary"
                                                onClick={function aFe(){navigate("/overview/news", { state: { currentFilters: currentFilters, loadPreviousSelection:true }})}} // /overview/news?restore=1
                                                iconLeading="arrow_back"
                                                style={{margin:"0px 10px"}}
                                            />
                                    </div>
                            </footer>
                        
                        </>

                    }    

                </>    
		)
	}
}

export default DetailNews;